import PayResult from '@/components/PayResult'
const PayCancel = () => {
    const element = <PayResult resultType={2} />
    return element
}
export default PayCancel